import React from 'react'

import * as ROUTES from '../Constants/routes';

import Card from 'react-bootstrap/Card';
import CardColumns from 'react-bootstrap/CardColumns';
import Button from 'react-bootstrap/Button';

function Pub() {
    return(
        <div style={{
            height: '100vh',
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}>
        <CardColumns style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}>
            <Card style={{ width: '18rem' }}>
                <Card.Img variant="top" src="" />
                <Card.Body>
                    <Card.Title>Math</Card.Title>
                    <Card.Text>
                        The Queen of Sciences.
                    </Card.Text>
                    <Button variant="primary" href={ROUTES.PUBLICATIONS_MATH}>Math</Button>
                </Card.Body>
            </Card>
            <Card style={{ width: '18rem' }}>
                <Card.Img variant="side" src="" />
                <Card.Body>
                    <Card.Title>Code</Card.Title>
                    <Card.Text>
                        The building block of, well, the digital world.
                    </Card.Text>
                    <Button variant="primary" href={ROUTES.PUBLICATIONS_CODE}>Code</Button>
                </Card.Body>
            </Card>
        </CardColumns>
        </div>
    );
}

export default Pub;